import React from 'react';
import { connect } from 'react-redux';
import { StatisticsContent } from './StatisticsContent.js';
import { actions } from './StatisticsContent.actions';

const StatisticsContentComponent = connect(
    function mapStateToProps(state) {
        return {
            loadingData: state.statistics.data.loading,
            totalPages: state.statistics.data.total,
            page: state.statistics.data.page
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            search: actions.search,
            searchChart: actions.searchChart,
            setQuery: actions.setQuery
        };
    }
)(StatisticsContent);

export default StatisticsContentComponent;
